import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

const LEAD_API_URL = '/api/v2/leads';

@Injectable()
export class CustomerInfoService {
  constructor(private http: HttpClient) {}

  sendInformation(data: any) {
    return this.http
      .post(LEAD_API_URL, data)
      .pipe(
        catchError((error: any) =>
          202 === error.status ? of([]) : throwError(error),
        ),
      );
  }
}
